import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';

import {
  Badge,
  LoadingIndicator,
  SelectableItem,
  Text,
} from '@edume/magnificent';

import {teamIsMandatory} from '../../../../../utils/dueDateUtils';
import {
  getSmartTeamStatus,
  getTeamCountString,
  getTeamIcon,
} from '../../../../../utils/smartTeams';

import styles from '../../styles.module.scss';

const getEduMeTeamIcon = (intl, team) => {
  const displayString = team.isSmartTeam && getTeamCountString(team.segment);
  const isMandatoryTeam = teamIsMandatory(team);
  if (displayString) {
    const {pending} = getSmartTeamStatus(team.segment);
    return (
      <div styleName='team-icon-user-count'>
        {isMandatoryTeam && (
          <span styleName='mandatory-badge'>
            <Badge
              textContent={intl.formatMessage({
                id: 'Learning.assignTeams.mandatory',
              })}
              colour='brandPrimaryDark'
              compact
            />
          </span>
        )}
        <span>
          {intl.formatMessage({id: displayString.id}, displayString.data)}
        </span>
        {pending && (
          <div styleName='loading-indicator-container'>
            <LoadingIndicator indicator='generic' size='xsmall' color='dark' />
          </div>
        )}
      </div>
    );
  }

  return (
    <div styleName='team-icon-user-count'>
      {isMandatoryTeam && (
        <span styleName='mandatory-badge'>
          <Badge
            textContent={intl.formatMessage({
              id: 'Learning.assignTeams.mandatory',
            })}
            colour='brandPrimaryDark'
            compact
          />
        </span>
      )}
      <div styleName='num-users'>
        <Text size='s' colour='textSecondary'>{`${team.numUsers}`}</Text>
      </div>
      <span styleName='people-icon'>{getTeamIcon(team.isSmartTeam)}</span>
    </div>
  );
};

const SelectableTeamList = ({
  sourceIndex,
  teamsToDisplay,
  toggleSelection,
  isTeamSelected,
  intl,
}) =>
  [...teamsToDisplay].map((t, idx) => {
    const {id, name, disabled, externalGroupId} = t;
    const isFirstTeam = idx === 0;

    let secondaryText = null;

    if (externalGroupId || typeof id === 'string') {
      if (disabled) {
        secondaryText = intl.formatMessage(
          {id: 'Learning.assignTeams.teamAlreadyLinked'},
          {groupName: t.parentGroupName}
        );
      } else {
        // This is a "shell group", so we can't display numUsers and displaying
        // integration icon would be redundant
      }
    } else {
      secondaryText = getEduMeTeamIcon(intl, t);
    }

    return (
      <div
        key={idx}
        tabIndex={isFirstTeam ? -1 : 1}
        styleName={`${isFirstTeam ? 'no-top-margin' : ''}`}
      >
        <SelectableItem
          id={id}
          key={id}
          disabled={disabled}
          text={name}
          secondaryText={secondaryText}
          onClick={() => toggleSelection(sourceIndex, id)}
          selected={isTeamSelected(id, sourceIndex)}
          size={'single'}
          dataAutomation={'team-option'}
        />
      </div>
    );
  });

SelectableTeamList.propTypes = {
  sourceIndex: PropTypes.number.isRequired,
  teamsToDisplay: PropTypes.array.isRequired,
  toggleSelection: PropTypes.func.isRequired,
  isTeamSelected: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(CSSModules(SelectableTeamList, styles));
